window.scriptLoaded = window.scriptLoaded || {};
export const isMobile = (function () {
  const Android = function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry = function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS = function () {
      return (navigator.userAgent.match(/iPhone|iPad|iPod/i) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
        !window.MSStream;
    },
    Opera = function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows = function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any = function () {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    };

  return {
    Android: Android,
    BlackBerry: BlackBerry,
    iOS: iOS,
    Opera: Opera,
    Windows: Windows,
    any: any
  }
}());

export const isBrowser = (function () {
  const ie11 = function () {
      return !!window.MSInputMethodContext && !!document.documentMode;
    },
    Safari = function () {
      return navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    },
    edge = function () {
      return parseInt(window.navigator.userAgent.substring(window.navigator.userAgent.indexOf('Edge/') + 5, window.navigator.userAgent.indexOf('.', window.navigator.userAgent.indexOf('Edge/'))), 10);
    };

  return {
    ie11: ie11,
    Safari: Safari,
    edge: edge
  }
}());

const browserDetect = () => {
  let userAgent = navigator.userAgent;
  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = 'chrome';
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = 'firefox';
  } else if (userAgent.match(/safari/i)) {
    browserName = 'safari';
  } else if (userAgent.match(/opr\//i)) {
    browserName = 'opera';
  } else if (userAgent.match(/edg/i)) {
    browserName = 'edge';
  }

  document.documentElement.classList.add(browserName);
};
document.addEventListener('DOMContentLoaded', () => {
  browserDetect();
});
